import React from 'react';

function DoubleArmSurgicalPandant() {
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '16px',
    backgroundColor: '#fff',
  };

  const imageStyle = {
    maxWidth: '90%',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  };

  return (
    <div style={containerStyle}>
      <img
        src="/od3.png"
        alt="Double Arm Surgical Pendant"
        style={imageStyle}
      />
    </div>
  );
}

export default DoubleArmSurgicalPandant;
